import Seo from "@/components/Seo";
import { useState } from "react";
import { BLOG_POSTS } from "@/data/mockData";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

const TAGS = ["All", "Wellness", "Care", "Style", "Gifting", "Guide", "Heritage"];

export default function Blog() {
  const [q, setQ] = useState("");
  const [tag, setTag] = useState("All");
  const items = BLOG_POSTS.filter(b =>
    (tag === "All" || b.tag === tag) &&
    (q.trim() === "" || b.title.toLowerCase().includes(q.toLowerCase()))
  );
  const [feature, ...rest] = items;

  return (
    <div data-testid="page-blog" className="pt-32 pb-24">
      <Seo path="/blog" title="Journal" description="Notes on silver — care guides, styling ideas, hallmarking and heritage — from the SIRIJA studio." />
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="overline">Journal</div>
          <h1 className="mt-6 font-serif font-light text-5xl lg:text-7xl leading-[1] tracking-tight">
            Field notes on <span className="italic silver-shimmer">silver.</span>
          </h1>
          <p className="mt-8 text-[15px] text-[#2E2E2E]/75 max-w-xl font-light">
            Care guides, styling notes, and the stories behind our capsules.
          </p>
        </div>

        <div className="mt-12 flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div className="flex flex-wrap gap-2">
            {TAGS.map(t => (
              <button
                key={t}
                data-testid={`blog-tag-${t.toLowerCase()}`}
                onClick={() => setTag(t)}
                className={`text-[11px] uppercase tracking-[0.14em] px-4 py-2 rounded-full border transition-colors ${tag === t ? "border-[#1A1A1A] bg-[#1A1A1A] text-white" : "border-[#E5E5E5] hover:border-[#1A1A1A]"}`}
              >{t}</button>
            ))}
          </div>
          <div className="relative w-full md:w-72">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-[#A0A0A0]" />
            <Input data-testid="blog-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search articles" className="pl-11 h-11 rounded-full border-[#E5E5E5]" />
          </div>
        </div>

        {items.length === 0 ? (
          <div data-testid="blog-empty" className="py-24 text-center text-[#2E2E2E]/60">No articles match your search.</div>
        ) : (
          <>
            {feature && (
              <a href="#" data-testid={`blog-feature-${feature.slug}`} className="group mt-14 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
                <div className="aspect-[4/3] rounded-2xl overflow-hidden bg-[#F8F9FA]">
                  <img src={feature.image} alt={feature.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
                </div>
                <div>
                  <div className="overline">{feature.tag} · {feature.date}</div>
                  <h2 className="mt-4 font-serif text-4xl lg:text-5xl leading-tight tracking-tight">{feature.title}</h2>
                  <p className="mt-5 text-[#2E2E2E]/70">{feature.excerpt}</p>
                  <div className="mt-8 text-xs uppercase tracking-[0.2em] border-b border-[#1A1A1A] pb-1 inline-block group-hover:pl-2 transition-[padding]">Read article →</div>
                </div>
              </a>
            )}
            <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-10">
              {rest.map((b) => (
                <a key={b.id} href="#" data-testid={`blog-card-${b.slug}`} className="group block">
                  <div className="aspect-[4/3] rounded-xl overflow-hidden bg-[#F8F9FA]">
                    <img src={b.image} alt={b.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
                  </div>
                  <div className="mt-5 overline">{b.tag} · {b.date}</div>
                  <h3 className="mt-2 font-serif text-2xl tracking-tight leading-tight">{b.title}</h3>
                  <p className="mt-2 text-sm text-[#2E2E2E]/70 line-clamp-2">{b.excerpt}</p>
                </a>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
